import { create } from 'zustand';

export interface EffectClipDialogState {
  /** Dialog open state */
  open: boolean;
  /** 'add' = creating new, 'edit' = editing existing clip */
  mode: 'add' | 'edit';
  /** For 'add': the effect type key from EFFECT_CATALOG */
  effectType: string;
  /** For 'add': selection start/end */
  selectionStartMs: number;
  selectionEndMs: number;
  /** For 'edit': the existing effect clip id */
  effectClipId: string | null;
  /** Current params being edited (shared for add/edit) */
  params: Record<string, number>;

  openForAdd: (effectType: string, selectionStartMs: number, selectionEndMs: number, defaultParams: Record<string, number>) => void;
  openForEdit: (effectClipId: string, effectType: string, params: Record<string, number>) => void;
  updateParams: (params: Record<string, number>) => void;
  close: () => void;
}

export const useEffectClipDialogStore = create<EffectClipDialogState>((set) => ({
  open: false,
  mode: 'add',
  effectType: '',
  selectionStartMs: 0,
  selectionEndMs: 0,
  effectClipId: null,
  params: {},

  openForAdd: (effectType, selectionStartMs, selectionEndMs, defaultParams) =>
    set({
      open: true,
      mode: 'add',
      effectType,
      selectionStartMs,
      selectionEndMs,
      effectClipId: null,
      params: { ...defaultParams },
    }),

  openForEdit: (effectClipId, effectType, params) =>
    set({
      open: true,
      mode: 'edit',
      effectType,
      effectClipId,
      params: { ...params },
      selectionStartMs: 0,
      selectionEndMs: 0,
    }),

  updateParams: (params) =>
    set((s) => ({ params: { ...s.params, ...params } })),

  close: () => set({ open: false }),
}));
